const TESTIMONIALS = [
  {
    name: 'Adriana Carvalho',
    src: 'https://static.lumi.new/a6/a6d1f9dd80955cde41ff8275eec81d51.webp',
  },
  {
    name: 'Renilda',
    src: 'https://static.lumi.new/7e/7e15945dbaf25a66b6b5abb4758165ae.webp',
  },
  {
    name: 'Glória Alves',
    src: 'https://static.lumi.new/a0/a0ed360f87cc7c7f097c75b2316c1ee4.webp',
  },
  {
    name: 'Rosângela',
    src: 'https://static.lumi.new/27/27fe1a895b9a34234e00e5ed7e2ca9f6.webp',
  },
];

const CHOICES = [
  {
    label: '✦ Quero a Leitura do Campo Vibracional — um processo profundo e individual',
    href: 'https://leitura.reacendaluz.com.br',
  },
  {
    label: '✦ Quero uma sessão pontual com Mônica Maria',
    href: 'https://jornada.reacendaluz.com.br/sessao',
  },
  {
    label: '✦ Quero começar por algo acessível',
    href: 'https://elementos.reacendaluz.com.br/mapa',
  },
  {
    label: '✦ Quero apenas algo gratuito',
    href: 'https://elementos.reacendaluz.com.br',
  },
];

export default function Perfil() {
  return (
    <div style={{ background: '#0D0A12', minHeight: '100vh', color: '#FAFCF8' }}>
      <section
        style={{
          background: 'linear-gradient(180deg, #1A1228 0%, #0D0A12 100%)',
          marginTop: 0,
          marginBottom: 0,
        }}
        className="relative overflow-hidden"
      >
        <div
          className="absolute inset-0 pointer-events-none"
          style={{
            backgroundImage: 'radial-gradient(ellipse 60% 40% at 50% 18%, rgba(184,141,86,0.10) 0%, transparent 70%)',
          }}
        />
        <div className="relative max-w-3xl mx-auto px-6 pt-20 md:pt-28 pb-10 md:pb-14 text-center">
          <p
            style={{
              color: '#B88D56',
              fontFamily: 'Lora, Georgia, serif',
              letterSpacing: '0.18em',
              fontSize: '0.85rem',
              textTransform: 'uppercase',
            }}
            className="mb-6 tracking-widest"
          >
            Reacenda Luz
          </p>
          <h1
            style={{
              fontFamily: "'Cormorant Garamond', Georgia, serif",
              color: '#FAFCF8',
              fontWeight: 600,
              lineHeight: 1.25,
            }}
          >
            O que está travando a sua vida tem uma raiz. E ela pode ser revelada.
          </h1>
        </div>
      </section>

      <section className="max-w-2xl mx-auto px-6 py-8 md:py-10 text-center" style={{ marginTop: 0 }}>
        <p
          style={{
            fontFamily: 'Lora, Georgia, serif',
            color: '#FAFCF8',
            fontSize: '1.12rem',
            lineHeight: 1.9,
            marginBottom: '1.5rem',
          }}
        >
          A Leitura do Campo Vibracional é um processo profundo e individual com duração de 30 dias e várias etapas.
        </p>
        <p
          style={{
            fontFamily: 'Lora, Georgia, serif',
            color: 'rgba(250,252,248,0.88)',
            fontSize: '1.08rem',
            lineHeight: 1.9,
          }}
        >
          É um trabalho para remover bloqueios em todas as áreas da vida, liberando o que ainda prende e abrindo caminho para uma vida mais leve, próspera e alinhada com quem você realmente é.
        </p>
      </section>

      <div style={{ width: 48, height: 1, background: '#B88D56', margin: '0 auto' }} />

      <section className="max-w-2xl mx-auto px-6 py-16 md:py-20">
        <h2
          style={{
            fontFamily: "'Cormorant Garamond', Georgia, serif",
            color: '#FAFCF8',
            fontWeight: 500,
            textAlign: 'center',
            marginBottom: '2.75rem',
          }}
        >
          Quem já viveu a transformação.
        </h2>
        <div className="flex flex-col items-center" style={{ gap: '2.75rem' }}>
          {TESTIMONIALS.map((item) => (
            <img
              key={item.name}
              src={item.src}
              alt={`Depoimento de ${item.name}`}
              width={600}
              height={400}
              loading="lazy"
              decoding="async"
              style={{
                width: '100%',
                maxWidth: 600,
                height: 'auto',
                borderRadius: 12,
                display: 'block',
                boxShadow: '0 8px 32px rgba(0,0,0,0.45)',
                border: '1px solid rgba(184,141,86,0.22)',
              }}
            />
          ))}
        </div>
      </section>

      <div style={{ width: 48, height: 1, background: '#B88D56', margin: '0 auto' }} />

      <section className="max-w-xl mx-auto px-6 py-16 md:py-20">
        <h2
          style={{
            fontFamily: "'Cormorant Garamond', Georgia, serif",
            color: '#EFC98A',
            fontWeight: 500,
            textAlign: 'center',
            marginBottom: '2.25rem',
          }}
        >
          O que você escolhe agora?
        </h2>
        <div className="flex flex-col" style={{ gap: '1.25rem' }}>
          {CHOICES.map((choice) => (
            <a
              key={choice.href}
              href={choice.href}
              className="btn-cta-hover"
              style={{
                display: 'block',
                background: '#C8923A',
                color: '#FAFCF8',
                fontFamily: 'Lora, Georgia, serif',
                fontWeight: 500,
                fontSize: '1.05rem',
                lineHeight: 1.55,
                letterSpacing: '0.01em',
                textAlign: 'center',
                textDecoration: 'none',
                padding: '1.35rem 1.4rem',
                borderRadius: 8,
                border: '1px solid rgba(239,201,138,0.35)',
                boxShadow: '0 10px 28px rgba(200,146,58,0.18)',
                minHeight: 72,
              }}
            >
              {choice.label}
            </a>
          ))}
        </div>
      </section>

      <footer
        style={{
          borderTop: '1px solid rgba(184,141,86,0.12)',
          padding: '2rem 1.5rem 2.4rem',
          textAlign: 'center',
        }}
      >
        <p
          style={{
            fontFamily: 'Lora, Georgia, serif',
            color: 'rgba(184,141,86,0.55)',
            fontSize: '0.88rem',
            lineHeight: 1.8,
            marginBottom: '0.2rem',
          }}
        >
          Mônica Maria — Reacenda Luz
        </p>
        <p
          style={{
            fontFamily: 'Lora, Georgia, serif',
            color: 'rgba(184,141,86,0.45)',
            fontSize: '0.85rem',
          }}
        >
          @reacendaluz
        </p>
      </footer>
    </div>
  );
}
